var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: "80mm",
    width: "80mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      stopOpacity: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.921 0-5.842.056-8.76-.013-4.56-.107-7.364-2.243-8.194-6.17-.176-.833-.307-1.694-.311-2.544-.027-5.528-.101-11.059.012-16.585.112-5.499 2.893-8.44 8.197-8.635 5.992-.22 11.994-.202 17.986-.004 4.419.146 7.045 2.273 7.889 6.092.152.682.294 1.383.298 2.076.032 6.303.378 12.614-.191 18.905-.337 3.727-2.834 6.161-6.547 6.67C6.929.266 3.458-.071 0 0m-21.326-7.177c.374 1.948.722 3.903 1.783 5.635 2.422 3.952 6.208 5.469 10.573 5.575 5.953.146 11.915.143 17.868-.002 4.042-.098 7.64-1.429 10.101-4.932 1.584-2.256 2.175-4.838 2.215-7.507.087-5.722.127-11.448-.005-17.168-.106-4.607-1.708-8.538-6.021-10.881-1.993-1.081-4.177-1.551-6.406-1.577-5.878-.068-11.76-.125-17.635.009-4.409.101-8.24 1.589-10.689 5.582-1.062 1.732-1.41 3.688-1.784 5.636z",
    transform: "matrix(1.87705 0 0 -1.8936 40.03 7.842)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      stopOpacity: 1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.007 3.78-3.104 6.876-6.931 6.896-3.8.02-6.959-3.092-6.965-6.862-.006-3.78 3.106-6.876 6.931-6.896C-3.164-6.882-.006-3.771 0 0m4.095-.054C4.077-5.993-.851-10.874-6.902-10.947-12.973-11.02-18.008-6.008-17.99.088c.017 5.993 5.133 11.006 11.113 10.892C-.74 10.864 4.112 5.983 4.095-.054",
    transform: "matrix(1.87705 0 0 -1.8936 52.957 40.05)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      stopOpacity: 1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.465.019 2.703-1.194 2.695-2.638C2.688-4.023 1.5-5.209.081-5.25c-1.46-.042-2.726 1.149-2.751 2.588C-2.696-1.208-1.504-.019 0 0",
    transform: "matrix(1.87705 0 0 -1.8936 61.205 13.797)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.70054104247c538456109b9b22a07bd6.svg";
export { ForwardRef as ReactComponent };